module.exports = __webpack_public_path__ + "static/media/main.f335b323.png";